import flatpickr from 'flatpickr';

const datePicker = (selector, options) => {
    flatpickr(selector, { ...options, minDate: '01/01/1912' });
};

export default datePicker;
